import { useEffect } from 'react';

import {
  type PropertyTypeForOptions,
  isPropertyTypeInCompositeGroup,
} from '@modules/_shared/utils/propertyTypeHelpers';

type UseTransactionPropertyTypeSelectionOptions<
  T extends PropertyTypeForOptions,
> = {
  propertyTypes: readonly T[] | undefined;
  propertyTypeId: string | null | undefined;
  compositeType: string | null | undefined;
  onInvalidSelection: () => void;
  onSelectedPropertyType: (propertyType: T | undefined) => void;
};

export const useTransactionPropertyTypeSelection = <
  T extends PropertyTypeForOptions,
>({
  propertyTypes,
  propertyTypeId,
  compositeType,
  onInvalidSelection,
  onSelectedPropertyType,
}: UseTransactionPropertyTypeSelectionOptions<T>): void => {
  useEffect(() => {
    const selectedPropertyType = propertyTypes?.find(
      propertyType => propertyType.id === propertyTypeId,
    );

    if (
      selectedPropertyType != null &&
      !isPropertyTypeInCompositeGroup(selectedPropertyType, compositeType)
    ) {
      onInvalidSelection();
      return;
    }

    onSelectedPropertyType(selectedPropertyType);
  }, [
    compositeType,
    onInvalidSelection,
    onSelectedPropertyType,
    propertyTypeId,
    propertyTypes,
  ]);
};
